import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import PreguntaSnpComponent from '@/entities/snp/snippets/cuestionario/pregunta-snp.vue';
import {
  CuestionarioSnp,
  PreguntaCuestionarioSnp,
  RespuestaComparacion,
  RespuestaCuestionarioSnp,
} from '@/shared/model/snp/cuestionario.model';
import { IRevision } from '@/shared/model/revision.model';
import { RecomendacionValoracion } from '@/shared/model/snp/evaluacion.model';
import { VIGENCIA_PROGRAMA_NO_ACREDITADO, VIGENCIA_PROGRAMA_SI_ACREDITADO } from '@/shared/model/snp/snp-constants';

@Component({
  components: {
    'pregunta-snp': PreguntaSnpComponent,
  },
})
export default class CuestionarioSnpComponent extends Vue {
  @Prop({
    required: true,
    default: function () {
      return [];
    },
  })
  public preguntas: Array<PreguntaCuestionarioSnp>;

  @Prop({ required: false, default: false })
  public esMoloLectura: boolean;

  @Prop({ required: false, default: false })
  public mostrarRecomendacion: boolean;

  @Prop({
    required: false,
    default: function () {
      return new CuestionarioSnp();
    },
  })
  public cuestionarioInicial: CuestionarioSnp;

  @Prop({
    required: false,
    default: function () {
      return [];
    },
  })
  public revisionesIndividuales: Array<IRevision>;

  public contestaciones: { [preguntaId: number]: RespuestaCuestionarioSnp } = {};
  public comparaciones: Array<RespuestaComparacion> = [];

  public contestacionActual: RespuestaCuestionarioSnp = {};
  public preguntaActual: PreguntaCuestionarioSnp = {};
  public preguntaActualIndex = 1;
  public comentariosGenerales = '';
  public recomendacion: RecomendacionValoracion = new RecomendacionValoracion();

  @Watch('revisionesIndividuales')
  public watchRevisionesIndividuales(): void {
    this.comparaciones = [];
    (this.revisionesIndividuales ?? []).forEach(revision => {
      this.comparaciones.push(
        new RespuestaComparacion(
          revision.revisor.revisorId,
          (revision.respuesta?.resultados ?? new CuestionarioSnp()).contestaciones[this.preguntaActualIndex - 1],
          revision.respuesta?.resultados?.comentariosGenerales,
          revision.estado,
          revision.respuesta?.resultados?.recomendacion?.recomienda ?? undefined
        )
      );
    });
  }

  @Watch('cuestionarioInicial')
  public watchCuestionarioInicial(): void {
    if (this.cuestionarioInicial.contestaciones) {
      (this.cuestionarioInicial.contestaciones ?? []).forEach(contestacion => {
        this.contestaciones[contestacion.preguntaId] = contestacion;
      });
      this.comentariosGenerales = this.cuestionarioInicial.comentariosGenerales;
      this.recomendacion = this.cuestionarioInicial.recomendacion ?? new RecomendacionValoracion();
    }
    this.cambiarPagina(1);
    this.emiteCuestionario();
  }

  @Watch('preguntas')
  public watchPreguntas(): void {
    this.contestaciones = {};
    (this.preguntas ?? []).forEach(pregunta => {
      this.contestaciones[pregunta.id] = new RespuestaCuestionarioSnp();
    });
    this.cambiarPagina(1);
    this.emiteCuestionario();
  }

  public cambiarPagina(pagina) {
    this.preguntaActual = this.preguntas[pagina - 1];
    this.preguntaActualIndex = pagina;
    this.contestacionActual = this.contestaciones[this.preguntaActual.id] ?? new RespuestaCuestionarioSnp();
    this.watchRevisionesIndividuales();
  }

  public manejaContestarPregunta(respuestaAPregunta: RespuestaCuestionarioSnp): void {
    this.contestaciones[respuestaAPregunta.preguntaId] = respuestaAPregunta;
    this.emiteCuestionario();
  }

  public manejaRecomendacion(): void {
    this.recomendacion.aniosVigencia =
      this.recomendacion != undefined
        ? this.recomendacion.recomienda
          ? VIGENCIA_PROGRAMA_SI_ACREDITADO
          : VIGENCIA_PROGRAMA_NO_ACREDITADO
        : undefined;
    this.emiteCuestionario();
  }

  @Emit('change')
  public emiteCuestionario(): CuestionarioSnp {
    const listaContestaciones = [];
    const faltantes = [];
    let formCompleto = true;

    for (const [key, value] of Object.entries(this.contestaciones)) {
      listaContestaciones.push(value);
      if (key != undefined && key != 'undefined') {
        if (!(value.respuestaId && ((value.campoTexto && value.respuestaCampoTexto) || !value.campoTexto))) {
          faltantes.push(key);
          formCompleto = false;
        }
      }
    }

    formCompleto &&= !!this.comentariosGenerales;

    if (this.mostrarRecomendacion) {
      formCompleto &&= this.recomendacion.recomienda != undefined;
    } else {
      this.recomendacion = new RecomendacionValoracion();
    }

    return new CuestionarioSnp(listaContestaciones, this.comentariosGenerales, formCompleto, faltantes, this.recomendacion);
  }
}
